var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"default-layout"}},[(_vm.loaded)?[_c('RouterView',{key:_vm.$route.fullPath})]:_vm._e(),(_vm.$modal.visible)?_c('AppModal'):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }